import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

//styles
import { Flex } from 'components/styled/Flex';
import { DefaultButton } from 'components/styled/Button';
import { IconWrapper } from './NextButton.styled';
//assets
import { ArrowRightIcon } from 'assets/icons';
import { useTheme } from 'styled-components';

interface INextButton {
  to: string;
  disabled: boolean;
  label: string;
  onClick?: () => void;
}

export const NextButton = ({ to, disabled, label, onClick = () => null }: INextButton) => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <Flex width="100%" justifyContent="flex-end" margin="2rem 0 0 0">
      <Link to={to}>
        <DefaultButton
          onClick={onClick}
          type="button"
          color="light-green"
          disabled={!disabled}
          svgHoverColor={disabled ? 'white' : '#e8e8e8'}
        >
          {t(label)}
          <IconWrapper>
            <ArrowRightIcon rotate={180} stroke={colors.positive_dark} />
          </IconWrapper>
        </DefaultButton>
      </Link>
    </Flex>
  );
};
